<template>
  <div class="searchResult" style="margin-top: 0px;"> 

    <div class="filterCondition" style="margin-bottom: 10px;text-align: left;">
      <a-space>
        <a-button type="primary" @click="batchCancel" :disabled="selectedRowKeys.length == 0">
          批量取消 ( {{ selectedRowKeys.length }} )</a-button> 
      </a-space>
    </div>

<a-spin :spinning="spinning" tip="加载中...">
<a-table :columns="columns" :rowKey="(record) => record.id" :data-source="data" :pagination="pagination"
  @change="handleTableChange" :rowSelection="{
                selectedRowKeys,
                onChange: onSelectChange,
                getCheckboxProps: record => ({
                  props: {
                    disabled: record.status != 1,
                    name: record.status != 1 ? '该任务不可选择' : ''
                  },
                })
              }"  :scroll="{ x: 2000 }"  
  >

  <div slot="method" slot-scope="text" v-if="text == 'copy'">复制计划</div>
  <div slot="method" slot-scope="text" v-else-if="text == 'create'">新建计划</div>

  <div slot="marketing_goal" slot-scope="text" v-if="text == 'LIVE_PROM_GOODS'"><a-icon type="play-square" /> 直播带货</div>
  <div slot="marketing_goal" slot-scope="text" v-else-if="text == 'VIDEO_PROM_GOODS'"><a-icon type="picture" /> 短视频带货</div>


  <div class="aweme" slot="aweme" slot-scope="text">
      <div class="aweme-left">
        <img slot="aweme_avatar"  class="awemeimg" :src="text.tf_aweme_avatar"
          v-if="text.tf_aweme_avatar" />
      </div>
      <div class="aweme-right">
        <div class="aweme-title" >{{ text.tf_aweme_name }}</div>
        <div class="aweme-name" >抖音号：{{ text.tf_aweme_id }}</div>
        <div class="aweme-id">户ID：{{ text.advertiser_id }}</div>
      </div>
    </div>

    <div class="aweme" slot="btf_aweme" slot-scope="text">
      
      <template v-if="text.marketing_goal == 'VIDEO_PROM_GOODS'">
        <div class="aweme-left">
          <img   @click="govideo(text)" class="videoimg" :src="text.video_cover_url"
            v-if="text.video_cover_url" />
        </div>
        <div class="aweme-right">
          <div class="aweme-title" @click="getDetail(text)">{{ text.title }}</div>
          <div class="aweme-id" style="margin-top: 10px;">视频ID：{{ text.aweme_item_id }}</div>
          <div class="aweme-name">抖音：{{ text.aweme_name }} ({{ text.aweme_id }})</div>
          <!-- <div class="aweme-id">抖音号：</div> -->
        </div>
      </template>
      <template v-else>
        <template v-if="text.liveroom_heat_mode == 'BY_VIDEO' ">
          <div class="aweme-left">
            <img  @click="govideo(text)" class="videoimg" :src="text.video_cover_url"
              v-if="text.video_cover_url" />
          </div>
          <div class="aweme-right">
            <div class="aweme-title" @click="getDetail(text)">{{ text.title }}</div>
            <div class="aweme-id" style="margin-top: 10px;">视频ID：{{ text.aweme_item_id }}</div>
            <div class="aweme-name">抖音：{{ text.aweme_name }} ({{ text.aweme_id }})</div>
            <!-- <div class="aweme-id">抖音号：</div> -->
          </div>
        </template>
        <template v-else>
          <div class="aweme-left">
            <img  @click="govideo(text)" class="awemeimg" :src="text.video_cover_url"
              v-if="text.video_cover_url" />
          </div>
          <div class="aweme-right">
            <div class="aweme-title" @click="getDetail(text)">{{ text.title }}</div> 
            <div class="aweme-name">抖音号：{{ text.aweme_id }}</div>
            <div class="aweme-id">抖音名称：{{ text.aweme_name }} </div>
          </div>
        </template>
      </template>
    </div>

  <a-tag slot="status" color="gray" slot-scope="text" v-if="text == '-1'">任务取消</a-tag>
  <a-tag slot="status" color="orange" slot-scope="text" v-else-if="text == '1'">等待执行</a-tag>
  <a-tag color="pink" slot="status" slot-scope="text" v-else-if="text == '2'">执行中</a-tag>
  <a-tag color="green" slot="status" slot-scope="text" v-else-if="text == '3'">执行完成</a-tag>
  <a-tag slot="status" color="gray" slot-scope="text" v-else-if="text == '5'">任务过期</a-tag>

  

  <b slot="times"  slot-scope="text">{{ text }}</b>

  
  <b slot="success_times" style="color:green"  slot-scope="text">{{ text||'0' }}</b>
  
  <b slot="error_times" style="color:red"  slot-scope="text">{{ text||'0' }}</b>


 

  <div class="rowOperate" slot="action" slot-scope="text, record">
    <a-space>
      <a slot="action" class="actionItem" @click="getDetail(record)">任务进度</a>
      <a slot="action" class="actionItem" @click="cancelTaskAction(record)" style="color: red;margin-left: 10px;"
        v-if="text.status == 1">取消任务</a>
    </a-space>
  </div>



</a-table>
</a-spin>

<a-drawer :visible="detailVisible" title="任务详情" width="1000px" placement="right" @close="detailVisible = false">
  <div class="searchResult">
        <div style="margin-bottom: 20px;">
          <span style="font-size: 16px;font-weight: 600;color: #333;">投放号：{{ order_detail.tf_aweme_name }} ({{ order_detail.tf_aweme_id }}) 户ID：{{ order_detail.advertiser_id }}</span>
        </div>
        <div class="name flex">
          <div class="flex">
            <img class="avatar" :src="order_detail.video_cover_url" />
          </div>
          <div >
            <div>{{ order_detail.title }}</div>
            <span v-if="order_detail.aweme_item_id">视频ID：{{ order_detail.aweme_item_id }}</span>
            <div style="font-size: 12px;color: #999;">被投抖音号：{{ order_detail.aweme_name }}({{ order_detail.aweme_id }})</div>
          </div>
        </div>
        <div class="tags-container">
          <div class="title" style="margin-top: 0px;">投放设置</div>
            <div class="delivery-tab">
              <div class="setting-item">
                <label>投放金额</label>
                <div class="display-value">
                  <div>{{ order_detail?.data?.delivery_setting?.amount }} 元</div>
                </div>
              </div>
              <div class="setting-item">
                <label>优化目标</label>
                <div class="display-value">
                  <div>
                    {{ getStatusText(order_detail?.data?.delivery_setting?.external_action) }}
                  </div>
                </div>
              </div>
              <div class="setting-item">
                <label>曝光时长</label>
                <div class="display-value">
                  <div>{{ order_detail?.data?.delivery_setting?.delivery_time }} 小时</div>
                </div>
              </div>
              <div class="setting-item">
                <label>出价模式</label>
                <div class="display-value">
                  <div v-if="order_detail?.data?.delivery_setting?.bid_mode == 'PRICING_ACTION'">
                    按优化目标出价
                  </div>
                  <div v-else>按播放量出价</div>
                </div>
              </div>


              <div class="setting-item">
                <label>出价类型</label>
                <div class="display-value">
                  <div v-if="order_detail?.data?.delivery_setting?.bid_type == 'AUTO_BID'">
                    自动出价
                  </div>
                  <div v-else>手动出价</div>
                </div>
              </div>

              <div class="setting-item" v-if="order_detail?.data?.delivery_setting?.cpa_bid">
                <label>手动出价</label>
                <div class="display-value">
                  <div>
                    {{ order_detail?.data?.delivery_setting?.cpa_bid }}
                  </div>
                </div>
              </div>

              <div class="setting-item" v-if="order_detail?.data?.delivery_setting?.roi_goal">
                <label>支付ROI目标</label>
                <div class="display-value">
                  <div>
                    {{ order_detail?.data?.delivery_setting?.roi_goal }}
                  </div>
                </div>
              </div>
              <div class="setting-item" v-if="order_detail?.data?.delivery_setting?.liveroom_heat_mode">
                <label>直播间加热方式</label>
                <div class="display-value">
                  <div v-if="
                    order_detail.data?.delivery_setting?.liveroom_heat_mode == 'BY_ROOM'
                  ">
                    直接加热直播间
                  </div>
                  <div v-else>选择视频加热直播间</div>
                </div>
              </div>
            </div>
            <div style="clear: both;"></div>
            <div class="title">定向人群</div>
            <div class="delivery-tab">
              
              <div class="setting-item">
                <label>潜在用户</label>
                <div class="display-value"> 
                  <div v-if="order_detail?.data?.audience?.audience_mode == 'ATUO'">系统智能推荐</div>
                  <div v-else-if="order_detail?.data?.audience?.audience_mode == 'CUSTOM'">自定义</div>
                  <div v-else-if="order_detail?.data?.audience?.audience_mode == 'FANS'">达人相似粉丝</div>
                  <div v-else-if="order_detail?.data?.audience?.audience_mode == 'LIVEFANS'">达人相似观众</div>
                </div>
              </div>
            
            </div>
            <div class="delivery-tab"  v-if="order_detail?.data?.audience?.audience_mode != 'ATUO'">
              
              <div class="setting-item" >
                <label>性别</label>
                <div class="display-value"> 
                  <div v-if="order_detail?.data?.audience?.gender == 'GENDER_FEMALE'">女性</div>
                  <div v-else-if="order_detail?.data?.audience?.gender == 'GENDER_MALE'">男性</div>
                  <div v-else="">不限</div> 
                </div>
              </div>
              
              <div class="setting-item" >
                <label>年龄</label>
                <div class="display-value" v-if="order_detail?.data?.audience?.age && order_detail?.data?.audience?.age.length>0"> 
                  <span  v-for="(item, index) in order_detail?.data?.audience?.age" :key="index" >
                    <b v-if="item=='AGE_BETWEEN_18_23'">18-23岁、</b>
                    <b v-if="item=='AGE_BETWEEN_24_30'">24-30岁、</b>
                    <b v-if="item=='AGE_BETWEEN_31_40'">31-40岁、</b>
                    <b v-if="item=='AGE_BETWEEN_41_50'">41-50岁、</b>
                  </span> 
                </div>
                <div class="display-value" v-else=""> 
                  <div>不限</div> 
                </div>
              </div>

              <div class="setting-item" >
                <label>限运地区</label>
                <div class="display-value" > 
                  <div  v-if="order_detail?.data?.audience?.exclude_limited_region == '1' ">排除</div> 
                  <div  v-if="order_detail?.data?.audience?.exclude_limited_region == '0'">不排除</div> 
                </div>
              </div>

              <div class="setting-item" v-if="order_detail?.data?.audience?.citystr">
                <label>地域定向</label>
                <div class="display-value" > 
                  <span  v-for="(item, index) in order_detail?.data?.audience?.citystr" :key="index" >
                    {{item}}
                  </span> 
                </div>
              </div>

              <div class="setting-item" v-if="order_detail?.data?.audience?.interest_categories">
                <label>兴趣定向</label>
                <div class="display-value" > 
                  <span  v-for="(item, index) in order_detail?.data?.audience?.interest_categories" :key="index" >
                    <b v-if="item=='1000'">金融、</b> 
                    <b v-if="item=='1001'">汽车、</b> 
                    <b v-if="item=='1002'">旅游、</b> 
                    <b v-if="item=='1003'">房产、</b> 
                    <b v-if="item=='1004'">科技、</b> 
                    <b v-if="item=='1005'">娱乐、</b> 
                    <b v-if="item=='1006'">家装、</b> 
                    <b v-if="item=='1007'">生活、</b> 
                    <b v-if="item=='1008'">游戏、</b> 
                    <b v-if="item=='1009'">教育、</b> 
                    <b v-if="item=='1010'">体育、</b> 
                    <b v-if="item=='1011'">美食、</b> 
                    <b v-if="item=='1012'">母婴、</b> 
                    <b v-if="item=='1013'">法律、</b> 
                    <b v-if="item=='1014'">服饰、</b> 
                    <b v-if="item=='1015'">美妆、</b> 
                    <b v-if="item=='1016'">商务服务、</b> 
                  </span> 
                </div>
              </div>


            </div> 
            
        </div> 
      </div>

      <div class="title" >任务进度</div>



    <a-table :columns="detail_columns" :rowKey="(record) => record.id" :data-source="detail_data"
      :pagination="detail_pagination" @change="handleTableDetailChange">

      <a-tag slot="status" color="red" slot-scope="text" v-if="text == '0'">创建失败</a-tag>
      <a-tag color="green" slot="status" slot-scope="text" v-else-if="text == '1'">创建成功</a-tag>
    </a-table>
</a-drawer>



</div>
</template>
<script>
import { qcApi, requestHttp } from '@utils/index';
import { Modal } from 'ant-design-vue'; 
import aweme_avatar from '@/assets/images/sxt.png'
const columns = [
  {
    title: 'ID', dataIndex: 'id',
    key: 'id', width: 80,
    align: 'center',
  },
  // {
  //   title: '任务名称',
  //   dataIndex: 'method',
  //   key: 'method',
  //   scopedSlots: { customRender: 'method' },
  //   align: 'center',
  // },
  {
    title: '投放号',
    key: 'aweme',
    width: 300, 
    ellipsis: true,
    scopedSlots: { customRender: 'aweme' }, 
    align: 'center',
  },
  {
    title: '营销目标',
    dataIndex: 'marketing_goal',
    key: 'marketing_goal',
    width: 150, 
    scopedSlots: { customRender: 'marketing_goal' },
    align: 'center',
  },
  {
    title: '投放对象',
    key: 'btf_aweme',
    width: 300, 
    ellipsis: true,
    scopedSlots: { customRender: 'btf_aweme' },
    align: 'center',
  },
  {
    title: '投放笔数', dataIndex: 'times',
    align: 'center',
    scopedSlots: { customRender: 'times' }
  },
  {
    title: '成功笔数', dataIndex: 'success_times',
    align: 'center',
    scopedSlots: { customRender: 'success_times' }
  },
  {
    title: '失败笔数', dataIndex: 'error_times',
    align: 'center',
    scopedSlots: { customRender: 'error_times' }
  },
  {
    title: '任务状态', dataIndex: 'status',
    align: 'center',
    scopedSlots: { customRender: 'status' }
  },
  {
    title: '创建时间', dataIndex: 'createtime',
    align: 'center',
    scopedSlots: { customRender: 'createtime' }
  },
  {
    title: '执行时间', dataIndex: 'dotime',
    align: 'center',
    scopedSlots: { customRender: 'dotime' }
  },
  {
    title: '完成时间', dataIndex: 'completetime',
    align: 'center',
    scopedSlots: { customRender: 'completetime' }
  },
  {
    title: '操作',
    key: 'operation',
    align: 'center',
    fixed: 'right',
    width: 200,
    scopedSlots: { customRender: 'action' },
  },
];
const detail_columns = [
  {
    title: 'ID', dataIndex: 'id',
    key: 'id', width: 150
  },
  {
    title: '订单ID',
    dataIndex: 'order_id',
    key: 'order_id',
    scopedSlots: { customRender: 'order_id' },
  },
  {
    title: '执行状态',
    dataIndex: 'status',
    key: 'status',
    scopedSlots: { customRender: 'status' },
  },
  {
    title: '状态结果',
    dataIndex: 'remark',
    key: 'remark',
    scopedSlots: { customRender: 'remark' },
  },
  {
    title: '创建时间', dataIndex: 'createtime',
    scopedSlots: { customRender: 'createtime' }
  }
];
const data = [];
const key = 'updatable';
export default {
  name: 'planManage',
  props: {
      timeType: {
          type: String,
          default: '',
      },
      new_marketing_goal: {
          type: String,
          default: '',
      },
      advertiser_id: {
          type: String,
          default: '',
      },
      aweme_id: {
          type: String,
          default: '',
      },
      aweme_item_id: {
          type: String,
          default: '',
      },
      plan_id: {
          type: String,
          default: '',
      },
  },
  data() {
    return {
      detailVisible: false,
      data,
      detail_id: '',
      columns,
      detail_columns,
      detail_data: [],
      detail_page: 1,
      detail_pagesize: 10,
      pagination: {
        // size: 'large',
        current: 1,
        pageSize: 10,
        total: 0,
        // pageSizeOptions: ['10', '20', '30'], // 可选的页面显示条数
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条';
        }, // 展示每页第几条至第几条和总数
        hideOnSinglePage: false, // 只有一页时是否隐藏分页器
        showQuickJumper: true, // 是否可以快速跳转至某页
        showSizeChanger: true, // 是否可以改变pageSize
      },
      detail_pagination: {
        // size: 'large',
        current: 1,
        pageSize: 10,
        total: 0,
        // pageSizeOptions: ['10', '20', '30'], // 可选的页面显示条数
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条';
        }, // 展示每页第几条至第几条和总数
        hideOnSinglePage: false, // 只有一页时是否隐藏分页器
        showQuickJumper: true, // 是否可以快速跳转至某页
        showSizeChanger: true, // 是否可以改变pageSize
      },
      deadline: Date.now() + 1000 * 11,
      deadtitle: '定时刷新中：倒计时',
      page: 1,
      pagesize: 10, 
      spinning:false,
      order_detail:{},
      selectedRow: [],
      selectedRowKeys: [],
    };
  },
  components: {
  },
  watch: {
    timeType(a,b){
      console.log('99999999999')
      this.page = 1
      this.list = []
      this.getData()
    },
    advertiser_id(a,b){
      this.page = 1
      this.list = []
      this.getData()
    },
    new_marketing_goal(a,b){
      this.page = 1
      this.list = []
      this.getData()
    },
    aweme_id(a,b){
      this.page = 1
      this.list = []
      this.getData()
    },
    aweme_item_id(a,b){
      this.page = 1
      this.list = []
      this.getData()
    },
    plan_id(a,b){
      this.page = 1
      this.list = []
      this.getData()
    },
  },
  async mounted() {
    this.getData()
  },
  methods: {
    getStatusText(status){
      let text = ''
      // AD_CONVERT_TYPE_LIVE_CLICK_PRODUCT_ACTION: 直播间商品点击
      // AD_CONVERT_TYPE_LIVE_ROI: 支付ROI
      // AD_CONVERT_TYPE_LIVE_SUCCESSORDER_ACTION: 直播间下单
      // AD_CONVERT_TYPE_LIVE_SUCCESSORDER_PAY: 直播间成交
      // AD_CONVERT_TYPE_NEW_FOLLOW_ACTION: 直播间粉丝提升

      // AD_CONVERT_TYPE_LIVE_HEAT：直播间加热
      // 当营销目标为短视频带货时，允许值：
      // AD_CONVERT_TYPE_QC_FOLLOW_ACTION: 粉丝提升
      // AD_CONVERT_TYPE_QC_MUST_BUY: 点赞评论
      // AD_CONVERT_TYPE_SHOPPING: 商品购买
 
      switch (status) {
        case 'AD_CONVERT_TYPE_LIVE_SUCCESSORDER_PAY':
          text = '直播间成交'
          break;
        case 'AD_CONVERT_TYPE_LIVE_SUCCESSORDER_ACTION':
          text = '直播间下单'
          break;
        case 'AD_CONVERT_TYPE_LIVE_CLICK_PRODUCT_ACTION':
          text = '直播间商品点击'
          break;
        case 'AD_CONVERT_TYPE_LIVE_ROI':
          text = '支付ROI'
          break;
        case 'AD_CONVERT_TYPE_LIVE_HEAT':
          text = '直播间加热'
          break;
        case 'AD_CONVERT_TYPE_QC_FOLLOW_ACTION':
          text = '粉丝提升'
          break;
        case 'AD_CONVERT_TYPE_QC_MUST_BUY':
          text = '点赞评论'
          break;
        case 'AD_CONVERT_TYPE_SHOPPING':
          text = '商品购买'
          break;
        default:
          break;
      }
      return text
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRow = selectedRows;
      this.selectedRowKeys = selectedRowKeys;
      console.log('selectedRowKeys changed: ', this.selectedRow, this.selectedRowKeys);
    },
    govideo(e) {
      console.log(e)
      const strUrl = 'https://www.douyin.com/video/' + e.aweme_item_id;
      let a = document.createElement('a');
      document.body.appendChild(a);
      a.style = 'display: none';
      a.target = '_blank';
      a.href = strUrl;
      a.click();
      document.body.removeChild(a);
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },  
    cancelTaskAction(item) {
      Modal.confirm({
        title: '提醒',
        content: '确认是否取消任务？',
        onOk: () => {
          this.cancelTask(item)
        },
      });
    },
    async cancelTask(item) {
      console.log(item)
      const { code, msg, data } = await requestHttp({
        api: `${qcApi.CANCEL_TASK}`,
        method: 'POST',
        params: {
          task_id: item.id,
        },
      });
      this.loading = false;
      if (code == 0) {
        this.$message.error(msg);
        return;
      }
      this.$message.success(msg);
      this.getData()
    },  
    getDetail(e) {
      console.log(e)
      this.order_detail = e
      this.detail_id = e.id
      this.getDetailData();
    },
    async getDetailData() {
      const { code, msg, data } = await requestHttp({
        api: `${qcApi.GET_TASK_DETAIL}`,
        method: 'POST',
        params: {
          task_id: this.detail_id,
          page: this.detail_page,
          pagesize: this.detail_pagesize,
        },
      });
      this.loading = false;
      if (code == 0) {
        this.$message.error(msg);
        return;
      }
      console.log(data);
      if (!data) return;
      this.detailVisible = true
      this.detail_data = data.list
      this.detail_pagination.total = data.count
    },
    handleTableDetailChange(e) {
      console.log(e);
      this.detail_pagination = e;
      this.loading = true;
      this.detail_page = e.current;
      this.detail_pagesize = e.pageSize;
      this.getDetailData();
    },
    async getData() {
      console.log(111)
      this.spinning = true
      const { code, msg, data } = await requestHttp({
        api: `${qcApi.GET_TASK_LIST}`,
        method: 'POST',
        params: {
          advertiser_id: this.advertiser_id,
          page: this.page,
          pagesize: this.pagesize,
          marketing_goal: this.timeType,
          aweme_id:this.aweme_id,
          aweme_item_id:this.aweme_item_id,
          plan_id:this.plan_id,
          new_marketing_goal:this.new_marketing_goal
        },
      });
      this.spinning = false
      if (code == 0) {
        this.$message.error(msg);
        return;
      }
      console.log(data);
      if (!data) return;
      this.data = data.list
      this.pagination.total = data.count

      this.$emit('getTasklist',data)


    },
    handleTableChange(e) {
      console.log(e);
      this.pagination = e;
      this.loading = true;
      this.page = e.current;
      this.pagesize = e.pageSize;
      this.getData();
    },
    batchCancel() {
      Modal.confirm({
        title: '批量取消确认',
        content: `确认要取消选中的 ${this.selectedRowKeys.length} 个任务吗？`,
        onOk: () => {
          this.batchCancelTask();
        },
      });
    },
    
    async batchCancelTask() {
      this.spinning = true;
      let successCount = 0;
      let failCount = 0;
      
      // Process each selected task
      for (const taskId of this.selectedRowKeys) {
        try {
          const { code, msg } = await requestHttp({
            api: `${qcApi.CANCEL_TASK}`,
            method: 'POST',
            params: {
              task_id: taskId,
            },
          });
          
          if (code == 1) {
            successCount++;
          } else {
            failCount++;
          }
        } catch (error) {
          failCount++;
          console.error('取消任务失败:', error);
        }
      }
      
      this.spinning = false;
      
      if (successCount > 0) {
        this.$message.success(`成功取消${successCount}个任务`);
      }
      
      if (failCount > 0) {
        this.$message.error(`${failCount}个任务取消失败`);
      }
      
      // Clear selection and refresh data
      this.selectedRowKeys = [];
      this.selectedRow = [];
      this.getData();
    },
  },
};
</script>

<style lang="less" scoped>
.planManage {
  .searchWapper {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    position: relative;

    .selectType {
      width: 166px;
    }
  }

  .searchResult {
    margin-top: 20px;
  }
}

.ant-statistic {
  position: absolute;
  right: 20px;
  top: 0px;
}

.videoimg {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  cursor: pointer;
}
.aweme {
  display: flex;
}
.videoimg {
  width: 50px;
  height: 70px;
  border-radius: 3px;
  cursor: pointer;
}
.aweme-right {
  padding-left:30px;
  text-align: left;
  padding-left: 10px;
  width: 180px;
  .aweme-title {
    color: #000;
    font-weight: bold; 
    cursor: pointer;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    width: 200px;
  }
}
.planManage {
  .searchWapper {
    display: flex;
    align-items: center;
    justify-content: flex-start;

    .selectType {
      width: 166px;
    }
  }

  .searchResult {
    margin-top: 20px;
  }
} 
.awemeimg {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  cursor: pointer;
}  

.tags-container {
  padding: 16px 0px;
  overflow: hidden;
}

.tags-container .ad-tag {
  float: left;
  margin-left: 16px;
}

.tags-container .ad-tag:first-child {
  margin-left: 0;
}

.tags-container .inbl {
  display: inline-block;
  vertical-align: middle;
}
.level-2 {
  margin-top: 15px;
  margin-bottom: 12px;
  line-height: 20px;
  font-weight: 600;
  font-size: 14px;
  color: #323335;
}
.cpa_bid {
  width: 150px;
  margin-left: 20px;
}
.tags-container .roi-input {
  position: relative;
  top: 1px;
}

.tags-container .roi-target-box {
  display: inline-block;
  margin-left: 24px;
}

.tags-container .info-item {
  float: left;
  height: 26px;
  display: flex;
  //  margin-left:24px;
  position: relative;
}


.tags-container .info-item.editable {
  padding-right: 28px;
}

.tags-container .info-item .content {
  display: inline-block;
  font-size: 14px;
  height: 26px;
  line-height: 26px;
  max-width: 250px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.tags-container .info-item .content .nobid-bid-content {
  color: #999;
}

.avatar {
  widows: 50px;
  height: 70px;
  border-radius: 5px;
  margin-right: 5px;
}
.searchResult {
  .name {
    color: #333;
    font-size: 14px;
    font-weight: 600;
    line-height: 24px;
    span{
      font-size: 12px;
      color: #999;
    }
  }
}
.tag {
  background: #f2f2f2;
  border-radius: 4px;
  color: #999;
  font-size: 14px;
  line-height: 22px;
  padding: 2px 8px;
  margin-right:10px;
  &:last-child{
    margin-right:0px;
  }
}

.tag.red {
  background: #fff1ef;
  color: #e5453f;
}

.tag.gray {
  background: #f2f2f2;
  color: #999;
}

.tag.green {
  background: #e6f8ee;
  color: #34ba7b;
}

.title {
  color: #333;
  font-size: 16px;
  font-weight: 600;
  line-height: 34px;
  margin-top: 20px;
}

.setting-item {
  display: flex;
  font-size: 14px;
  line-height: 20px;
  min-height: 44px;
  padding: 12px 16px;
  width: 50%;
  float: left;

  label {
    color: #333;
    flex-shrink: 0;
    font-weight: bold;
    margin-right: 24px;
    width: 80px;
  }

  .display-value {
    color: #333;
    flex: 1 1;
  }
}
.aweme-left{
  width: 70px;
}
</style>
